<template>
  <el-card :body-style="{ padding: '0px', cursor: 'pointer',border:'0px' }" class="bg-transparent " shadow="hover">
<!-- 如何有传入slot 用 solt ,要不设置默认的-->

    <header class="header-one" v-if="info.caseClass=='HW_CLASS'" @click="handleDetailsClick(info)" :style="style">
      <slot>
      <div class="hero__content">
        <div class="card-text-title">{{ info.title }}</div>
        <div class="card-text-desc">{{ info.subTitle }}</div>
      </div>
      </slot>

      <img :src="info.img" style="width: 100%"/>

    </header>
    <header class="header-two" v-else @click="handleDetailsClick(info)" :style="style">
      <slot>
      <div class="hero__content">
        <div class="card-text-title">{{ info.title }}</div>
        <div class="card-text-desc">{{ info.subTitle }}</div>
      </div>
      </slot>

      <img :src="info.img" style="width: 100%"/>

    </header>
  </el-card>
</template>
<script>
export default {
  name: 'EiiCard',
  props: {
    info: {},
    style:{},
    handleDetailsClick: {}
  }
}
</script>
<style lang="scss" scoped>

.bg-transparent {
  background-color: transparent;
  border: 0px;
}

@function svgColor($color) {
  @return "%23" + str-slice("#{$color}", 2, -1);
}

.header-two {
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  display: grid;
  grid-template-areas: "hero";
  grid-gap: 16px;
  place-items: center;
  //height: 60vh;
  max-height: 300px;

  overflow: hidden;

  width: 632px;
  height: 260px;


  > * {
    grid-area: hero;
  }

  img {
    object-fit: cover;

    // Chrome no longer preventing growing beyond
    // the header height with just the following
    height: 100%;
    width: 100%;
    // z-index: -1;
    overflow: hidden;
  }

  .hero__content {
    background-color: #0006;
    position: relative;
    left: 0;
    color: white;
    z-index: 1;
    text-align: center;
    display: flex;
    width: 632px;
    height: 100%;
    padding: 20px;
    transition: all 0.3s;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 16px;
    flex-shrink: 0;
&:hover{
  background-color: #fff0;
}
    .card-text-title {
      text-align: left;
      display: -webkit-box;
      width: 446px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;

      overflow: hidden;
      color: var(---FFF-100, #FFF);
      text-overflow: ellipsis;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 125% */
    }

    .card-text-desc {
      text-align: left;
      height: 40px;
      width: 100%;
      flex-shrink: 0;
      align-self: stretch;

      // overflow: hidden;
      color: var(--fff-80, rgba(255, 255, 255, 0.80));
      // text-overflow: ellipsis;
      // white-space: nowrap;
      // font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }
}

.header-one {
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  display: grid;
  grid-template-areas: "hero";
  grid-gap: 16px;
  place-items: center;
  //height: 60vh;
  max-height: 300px;

  overflow: hidden;

  width: 400px;
  height: 260px;


  > * {
    grid-area: hero;
  }

  img {
    object-fit: cover;

    // Chrome no longer preventing growing beyond
    // the header height with just the following
    height: 100%;
    width: 100%;
    // z-index: -1;
    overflow: hidden;
  }

  .hero__content {
    background-color: #0006;
    position: relative;
    left: 0;
    color: white;
    z-index: 1;
    text-align: center;
    display: flex;
    width: 400px;
    height: 100%;
    padding: 20px;
    transition: all 0.3s;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 16px;
    flex-shrink: 0;
&:hover{
  background-color: #fff0;
}
    .card-text-title {
      text-align: left;
      display: -webkit-box;
      width: 446px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;

      overflow: hidden;
      color: var(---FFF-100, #FFF);
      text-overflow: ellipsis;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 125% */
    }

    .card-text-desc {
      text-align: left;
      height: 40px;
      width: 100%;
      flex-shrink: 0;
      align-self: stretch;

      // overflow: hidden;
      color: var(--fff-80, rgba(255, 255, 255, 0.80));
      // text-overflow: ellipsis;
      // white-space: nowrap;
      // font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EiiCard.vue